import { render, staticRenderFns } from "./ServiceQuotation.vue?vue&type=template&id=462e570a&scoped=true"
import script from "./ServiceQuotation.vue?vue&type=script&lang=js"
export * from "./ServiceQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e570a",
  null
  
)

export default component.exports